<template>
	<div>
		<LeftMenu :currentIndex="2"></LeftMenu>
		<div class="d-flex">
			<div
				class="banner-item"
				v-for="(item, index) in newsList"
				:key="index"
				:class="[enlargeImgIndex === index ? 'active' : '', 'swiper-item-' + newsList.length]"
				@mouseover="enlargeImage(index)"
			>
				
				<img :src="item.imgSrc" class="imgItem" />
				<div class="overlay"><img :src="item.imgOverSrc" alt=""></div>
				<!-- <img :src="item.thumbImg" class="imgItem" v-show="enlargeImgIndex!=index"/>
				<img :src="item.imgSrc" class="imgItem" v-show="enlargeImgIndex===index"/> -->
				<div class="d-flex-item" v-if="enlargeImgIndex===index">
					<p class="con-title">{{item.title}}</p>
					<div class="con-item" v-for="(subItem,subIndex) in item.conList.slice(0,3)" :key="subIndex" @click="showDetail(subItem)">
						<p>{{subItem.date}}</p>
						<p class="con-desc">{{subItem.title}}</p>
						<p class="con-moreBtn"><img src="../../static/information/moreBtn.png"/></p>
					</div>
				</div>
				<div class="moreBtn" v-if="enlargeImgIndex===index" @click="nextSecond(index)">
					{{item.btnText}}
				</div>
			</div>
		</div>
		
		<NewsDetail :newsInfo="newsInfo" v-if="showDetailPage"></NewsDetail>
		<InformationSecond :list="contentList" v-if="showSecondPage" ></InformationSecond>
	</div>
</template>
<script>
import axios from 'axios';
import {eventBus} from '@/main.js'
export default {
	name: 'Information',
	components: {
		InformationSecond: () => import('./InformationSecond.vue'),
		NewsDetail: () => import('../components/NewsDetail.vue'),
		LeftMenu: () => import('../components/LeftMenu.vue')
	},
	props:{
		subActiveIndex:{
			type:Number,
			default: 0
		}
	},
	data() {
		return {
			appid: "sqks",
			api_secret: "abcdefg",
			timestamp: Date.parse(new Date()) / 1000,
			jiami:'',
			showSecondPage: false, //子组件显示
			showDetailPage: false, //内容详情
			showContentPage: false,//内容列表
			showType: 1 , // 1 内容列表页  2 详情页
			activeIndex: 0,
			enlargeImgIndex: 0,
			listResult: null,
			contentList:[], //内容数据
			newsInfo:{},
			newsList:[{
				title:"公司新闻",
				imgSrc: require("../../static/information/swiper-img1.png"),
				thumbImg: require("../../static/information/swiper-img1-thumb.png"),
				imgOverSrc: require("../../static/information/swiper-img1-over.png"),
				conList:[
					
				],
				btnText:"所有新闻"
			},{
				title:"科普知识",
				imgSrc: require("../../static/information/swiper-img2.png"),
				thumbImg: require("../../static/information/swiper-img2-thumb.png"),
				imgOverSrc: require("../../static/information/swiper-img2-over.png"),
				conList:[
					
				],
				btnText:"更多知识"
			},{
				title:"临床病例",
				imgSrc: require("../../static/information/swiper-img3.png"),
				thumbImg: require("../../static/information/swiper-img3-thumb.png"),
				imgOverSrc: require("../../static/information/swiper-img3-over.png"),
				conList:[
					
				],
				btnText:"查看更多"
			}]
		}
	},
	methods: {
		async getCompany() {
			//可进行解耦   公司新闻 17    科普知识 18    临床病例19    全部 12
			var that = this;
			await axios (
				{
					url: '//kingstronbio.slinqueen.com/api.php/list/12/num/100',
					method: 'POST',
					params: {
						"appid": this.appid,
						"signature": md5(md5(this.jiami)),
						"timestamp": this.timestamp,
					}
				}
			)
				.then(res => {
					that.listResult = res.data.data;
					that.newsList[0].conList = that.listResult.filter(item=>item.scode==="17"); //公司新闻
					that.newsList[1].conList = that.listResult.filter(item=>item.scode==="18"); //科普知识
					that.newsList[2].conList = that.listResult.filter(item=>item.scode==="19"); //临床病例
					
					that.$store.commit('setNews',that.newsList[0].conList[0]);
				}, error => {
					console.log(error)
				})

		},
		enlargeImage(index) {
			if (this.enlargeImgIndex !== index) {
				// 展开当前图像
				this.enlargeImgIndex = index;
			}
		},
		resetImage() {
			// 恢复默认状态
			this.enlargeImgIndex = 0;
		},
		nextSecond(index) {
			this.$router.replace({path:'/informationSecond'+'/'+index})
			this.showSecondPage = true;
			this.contentList = this.newsList[index].conList;
			this.$store.commit("setIsListening", false);
		},
		showDetail(item){
			this.$store.commit("setIsListening", false);
			this.showDetailPage = true ;//内容详情
			this.newsInfo = item;
		},
		closePage(){
			this.showSecondPage = false;
			this.showDetailPage = false;
			this.$store.commit("setIsListening", true);
		},
		closeModal(){
			this.$store.commit("setIsListening", true);
			this.showDetailPage = false;
		}
	},
	watch:{
		$route(to,from){
			if(to.name == 'information'){
				this.showSecondPage = false;
			}
		},
		isShowBack(val){
			if(!val){
				this.showSecondPage = false;
			}
		},
		subActiveIndex(val){
			if(val >= 0){
				this.showSecondPage = false;
				this.enlargeImgIndex = val;
			}
		},
	},
	mounted() {
		this.jiami = this.appid + this.api_secret + this.timestamp;
		this.getCompany()
		//二级页面 返回
		eventBus.$on('backPrevMenu', (index) => {
			this.showSecondPage = false;
			this.showDetailPage = false;
			this.$store.commit("setIsListening", true);
		});
	}
}
</script>
<style lang="less" scoped>
@import url('../assets/css/index.less');

.d-flex{
	display: flex;
	position: relative;
	.d-flex-item{
		color: #fff;
		font-size: 18/@r  !important;
		width: 635/@r;
		// height: 477/@r;
		overflow: hidden;
		.pos-a(182, 140, 4);
		.con-title{
			margin: 0 auto 20/@r;
			font-size: 30/@r;
			font-weight: 600;
		}
		.con-item{
			border-bottom: 1px solid #fff;
			cursor: pointer;
			p {
				margin-top: 10/@r;
			}
			.con-desc{
				font-size: 22/@r;
				
				overflow: hidden;
			  text-overflow: ellipsis;
			  display: -webkit-box;
			  -webkit-line-clamp: 2;
			  -webkit-box-orient: vertical;
			  display: -moz-box;
			  -moz-line-clamp: 2;
			  -moz-box-orient: vertical;
			  word-wrap: break-word;
			  word-break: break-all;
			  white-space: normal;    
			}
		}
		.con-moreBtn{
			margin: 10/@r 0 20/@r;
			.scale(121, 29);
			display: block;
		}
		p{
			margin: 0;
		}
		
	}
}

.el-carousel__arrow {
	position: absolute;
	top: 90% !important;
	left: 50%;
}
.banner-item {
	position: relative;
	width: 421/@r;
	height: 967/@r;
	overflow: hidden;
	transition: all 0.5s ease-in-out;
	&.banner-item:nth-child(1) {
		.imgItem {
			object-position: left;
		}
	}
	&.banner-item:nth-child(2) {
		.imgItem {
			object-position: right;
		}
	}
	&.banner-item:nth-child(3) {
		.imgItem {
			object-position: right;
		}
	}
	&.banner-item:nth-child(4) {
		.imgItem {
			object-position: right;
		}
	}
	.imgItem {
		width: 100%;
		height: 967/@r;
		// height: 100%;
		object-fit: cover;
		object-position: left;
		filter: grayscale(1);
		opacity: 0.85;
	}
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 967/@r;
		// background: rgba(229, 227, 225, 0.2);
		background: rgba(255, 255, 255, 0.7);
		img {
			.scale(422,176) !important;
			.pos-a(0, 0, 4);
			top:14.8%;
		}
	}
	&.active {
		width: 841/@r;
		.imgItem {
			width: 871/@r;
			filter: none;
			opacity: 1;
		}
		.overlay {
			opacity: 0;
			transition: all 0.5s ease-in-out;
		}
	}
	.moreBtn{
		position: absolute;
		top: 77.4%;
		left: 16.5%;
		z-index: 3;
		border: 1px solid #fff;
		border-radius: 20/@r;
		font-size: 16/@r;
		color: #fff;
		text-align: center;
		line-height: 43/@r;
		.scale(158,43) !important;
	}
}

// .d-content{
// 	.scale(1681,981) ;
// 	.pos-a(0, 0, 6);
// 	.mask{
// 		.pos-a(0, 0, 4);
// 		width: 100%;
// 		height: 100%;
// 		background-color: #e5e3e1;
// 	}
// 	.con-item{
// 		border-bottom: 1px solid #e5e3e1;
// 	}
// 	.m-title{
// 		font-size: 30/@r;
// 		margin: 20/@r auto;
// 		font-weight: bold;
// 		cursor: pointer;
// 	}
// 	.m-avator{
// 		.scale(250,129) ;
// 	}
// 	.mask-content{
// 		.pos-a-center(5);
// 		width: 70%;
// 		height:100%;
// 		z-index: 5;
// 		background: #fff;
// 		padding: 50/@r;
// 		overflow-y: auto;
// 	}
// 	.close-button {
// 	  position: absolute;
// 	  top: 20/@r;
// 	  right: 32/@r;
// 	  font-size: 40/@r;
// 	  cursor: pointer;
// 	  transition: color 0.3s;
// 	  .scale(38,38);
// 	  z-index: 6;
// 	  border-radius: 50%;
// 	  border: 1px solid #000;
// 	  text-align: center;
// 	  line-height: 38/@r;

// 	  &:hover {
// 	    color: #d9534f;
// 	  }
// 	}
// }
.el-row{
	margin: 20/@r auto;
}
@keyframes fadenum {
	0% {
		width: 421 / @r;
		height: 967/@r;
	}
	100% {
		width: 841 / @r !important;
		height: 967/@r;
	}
}
</style>
